import { render, staticRenderFns } from "./FormControlFieldSettings.vue?vue&type=template&id=684a99bf"
import script from "./FormControlFieldSettings.vue?vue&type=script&lang=js"
export * from "./FormControlFieldSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports